import { render, staticRenderFns } from "./login.vue?vue&type=template&id=2cec1820&"
import script from "./login.ts?vue&type=script&lang=js&"
export * from "./login.ts?vue&type=script&lang=js&"
import style0 from "./login.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports